import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import {
  LocationPermitComplianceAddFormModel,
  LocationPermitComplianceModel
} from 'app/edozvola/cases/location-permit-compliance/model/location-permit-compliance.model';
import {
  deleteLocationPermitCompliance,
  fetchLocationPermitCompliance,
  fetchLocationPermitComplianceData,
  fetchLocationPermitCompliancePage,
  fetchSavedLocationPermitCompliance,
  saveLocationPermitCompliance,
  saveLocationPermitComplianceData,
} from 'app/edozvola/cases/location-permit-compliance/service/location-permit-compliance.service';
import success = toast.success;
import error = toast.error;
import { messages, TABLE_QUERY_KEYS } from 'app/config/constants';

export const deleteLocationPermitComplianceQuery = (uuid: string, closeModalCallback: Function) => {
  return useMutation({
    mutationFn: (idLocationPermitComplianceMap: string) => deleteLocationPermitCompliance(uuid, idLocationPermitComplianceMap),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.LOCATION_PERMIT_COMPLIANCE_TABLE] });
      closeModalCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchLocationPermitCompliancePageQuery = (pagination: PaginationState, uuid: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.LOCATION_PERMIT_COMPLIANCE_TABLE, { ...pagination }, uuid],
    queryFn: ({ signal }) => fetchLocationPermitCompliancePage({ signal, pagination, uuid }),
  });
};

export const fetchSavedLocationPermitComplianceQuery = (uuid: string, idLocationPermitComplianceMap: string) => {
  return useQuery({
    queryKey: ['location-permit-compliance', { idLocationPermitComplianceMap: idLocationPermitComplianceMap }],
    queryFn: () => fetchSavedLocationPermitCompliance({ uuid, idLocationPermitComplianceMap }),
    enabled: !!idLocationPermitComplianceMap,
  });
};

export const fetchLocationPermitComplianceQuery = (uuid: string, webId: string) => {
  return useQuery({
    queryKey: ['location-permit-compliance', webId],
    queryFn: () => fetchLocationPermitCompliance({ uuid, webId }),
    enabled: !!webId,
  });
};

export const fetchLocationPermitComplianceDataQuery = (uuid: string) => {
  return useQuery({
    queryKey: ['location-permit-compliance-data', uuid],
    queryFn: () => fetchLocationPermitComplianceData({ uuid }),
    enabled: !!uuid,
  });
};

export const updateLocationPermitComplianceQuery = (uuid: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: LocationPermitComplianceAddFormModel) => saveLocationPermitCompliance(uuid, data),
    onSuccess: (data: LocationPermitComplianceAddFormModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.LOCATION_PERMIT_COMPLIANCE_TABLE] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const updateLocationPermitComplianceDataQuery = (uuid: string) => {
  return useMutation({
    mutationFn: (data: LocationPermitComplianceModel) => saveLocationPermitComplianceData(uuid, data),
    onSuccess: (data: LocationPermitComplianceModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({queryKey: ['location-permit-compliance-data']})
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
